import { ReactNode } from 'react';
import { TypoHeading2 } from '@/components/Typography';
import Button from '@/components/Button';
import Loader from '@/components/Loader.tsx';
import LogoutButton from '@/components/LogoutButton.tsx';
import useUser from '@/hooks/useUser.ts';
import UpdateProfileForm from './UpdateProfileForm.tsx';
import UpdatePasswordForm from './UpdatePasswordForm.tsx';
import ReferralSection from './ReferralSection.tsx';
import useEmailVerification from '@/hooks/useEmailVerification.ts';

const Profile = () => {
  const { user, loading } = useUser();
  const { isEmailVerified, ...rest } = user;

  if (loading) return <Loader />;

  return (
    <>
      {!isEmailVerified && <ResendEmailVerification />}

      <Container title="Update Profile">
        <UpdateProfileForm {...rest} />
      </Container>

      <Container title="Update Password">
        <UpdatePasswordForm />
      </Container>

      <Container title="Referrals">
        <ReferralSection />
      </Container>

      {/* Sign Out used to live in the sidebar only. On mobile the sidebar is gone,
          so the trigger is duplicated here (DESIGN section 8). */}
      <Container title="Sign Out" className="m:flex hidden">
        <LogoutButton className="m:h-12 m:w-full" />
      </Container>
    </>
  );
};

const ResendEmailVerification = () => {
  const { resendEmailVerification, loading } = useEmailVerification();

  return (
    <Container title="Email Verification">
      <Button onClick={() => resendEmailVerification()} loading={loading}>Resend Email Verification</Button>
    </Container>
  );
};

interface ContainerProps {
  title: string;
  children: ReactNode;
  className?: string;
}

const Container = ({ title, children, className = '' }: ContainerProps) => (
  <div className={`flex flex-col py-6 gap-4 ${className}`}>
    <TypoHeading2 className="text-neutral-text-strong font-medium px-10 m:px-4 m:pt-2 m:pb-3 m:text-heading2-m">
      {title}
    </TypoHeading2>
    <div className="w-full bg-neutral2 rounded px-10 py-8 m:px-4 m:py-5">
      {children}
    </div>
  </div>
);

export default Profile;
